import React from "react";
import { Modal } from "react-bootstrap";
import DynamicEventPreview from "./DynamicEventPreview";
import { getDesignName } from "./dynamicEventDesigns";

/**
 * Large modal wrapper around the live page preview. Opened from the
 * "Preview" link on a design card or a language row.
 *
 * Props: show, onHide, plus everything DynamicEventPreview accepts
 * (getEventObj, translations, designId, abTestEnabled, abTestDesignIds,
 * initialDesignId, initialLang).
 */
export default function DynamicEventPreviewModal({
  show,
  onHide,
  initialDesignId,
  initialLang,
  ...previewProps
}) {
  const designId = initialDesignId || previewProps.designId;
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      centered
      dialogClassName="design-preview-modal"
      fullscreen="lg-down"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Page preview
          <span className="design-preview-modal-sub">
            {getDesignName(designId)} design
            {initialLang && initialLang !== "en"
              ? ` · ${initialLang.toUpperCase()}`
              : ""}
          </span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {show ? (
          <DynamicEventPreview
            {...previewProps}
            initialDesignId={initialDesignId}
            initialLang={initialLang}
          />
        ) : null}
      </Modal.Body>
    </Modal>
  );
}
